"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newNominationDto = void 0;
function newNominationDto() {
    return {
        id: "",
        name: "",
        description: "",
        link: "",
        creatorId: ""
    };
}
exports.newNominationDto = newNominationDto;
//# sourceMappingURL=nomination.dto.js.map